module.exports = window.Object;